/* unplugin-vue-components disabled */import script from "./BasicPlanNotAuto.vue?vue&type=script&lang=ts&setup=true"
export * from "./BasicPlanNotAuto.vue?vue&type=script&lang=ts&setup=true"

import "./BasicPlanNotAuto.vue?vue&type=style&index=0&id=1ce403fc&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ce403fc"]])

export default __exports__